import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import permission from './modules/permission';
import app from './modules/app';
import crm from './modules/crm';
import getters from './getters';

Vue.use(Vuex);

var store = new Vuex.Store({
  modules: {
    app: app,
    permission: permission,
    user: user,
    crm: crm
  },
  getters: getters
});

export default store;